import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./layout/Loader";
import { authContext } from "./contexts/AuthProvider";

const Home = () => {
  const { isAuth } = useContext(authContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (isAuth === true) {
      navigate("/dashboard");
    }
    if (isAuth === false) {
      navigate("/login");
    }
  }, [isAuth]);
  return <Loader />;
};

export default Home;
